import { Component, booleanAttribute, input, output } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { DatePipe } from '../../pipes/date.pipe';
import { InputSelect } from '../input-select/input-select.component';

@Component({
  selector: 'procure-input-contacts',
  templateUrl: './input-contacts.component.html',
  styleUrl: './input-contacts.component.scss',
  imports: [NgSelectModule, ReactiveFormsModule, DatePipe, InputSelect],
})
export class InputContacts {
  readonly changed = output<string>();

  readonly appendTo = input<string>('body');
  readonly control = input.required<FormControl>();
  readonly label = input<string>('');
  readonly hint = input<string>('');
  readonly bindLabel = input<string | null>(null);
  readonly groupBy = input<string>('');
  readonly items = input<({ uuid: string } | string)[] | null | undefined>(
    null,
  );
  readonly clearAllText = input<string>('Clear selection');

  readonly showMode = input<boolean, boolean | string>(false, {
    transform: booleanAttribute,
  });
}
